import './spinner.scss';
import React, {memo} from 'react';

export const Spinner = memo(() => {
    return <div className="spinner" />;
});
